import { ICategory } from 'api/types/_category';
import { IPartner } from 'api/types/_news';
import DropdownOption from 'components/Common/DropdownOption';
import * as Yup from "yup";
import { useFormik } from 'formik';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Col, Input, Label, Modal, ModalBody, ModalHeader, Row, Spinner } from 'reactstrap';
import { toast } from 'react-toastify';
import { CONFIG_OPTION_TOAST_ERROR } from 'common/toast';
import DropdownMultiOption from 'components/Common/DropdownMultiOption';
import Hashtag from 'components/Common/Hashtag';
import TooltipCustom from 'components/Common/TooltipCustom';

interface ModalPartnerProps {
    isOpen: boolean;
    isPublishing: boolean;
    isShowCategoryOnPublish?: boolean,
    partners?: IPartner[],
    categories?: ICategory[]
    infoPublishDefault?: any,
    onPublish?: (info: {
        partner_id: number,
        partner_code_id: number,
        reporter_id?: number,
        // category_id?: number,
        // category_name?: string,
        reporter_byline?: string,
        tag?: string,
        keyword?: string,
        categories?: { id: null | number, name: string }[]
    }, is_refresh_category?: boolean) => void,
    onCloseClick?: () => void,
}

const ModalPartner: React.FC<ModalPartnerProps> = ({ partners, categories = [], isOpen, isPublishing, isShowCategoryOnPublish, infoPublishDefault, onPublish, onCloseClick }) => {
    const { t } = useTranslation();

    const [options, setOptions] = useState<any>([]);

    const [categoryOptions, setCategoryOptions] = useState<any>([]);

    const handleCloseClick = () => {
        onCloseClick && onCloseClick();
    }

    const handleSubmit = async (values: any) => {
        try {
            if (!!isPublishing) {
                return;
            }
            const categories_current = (values?.categories || [])?.filter((_c: any) => (!!_c?.value))?.map((_c: any) => ({
                id: Number(_c?.value),
                name: _c?.label || '',
            }));
            const categories_new = (values?.new_categories || [])?.filter((_c: any) => (!!_c?.id))?.map((_c: any) => ({
                id: null,
                name: _c?.id || '',
            }));
            const IS_REFRESH_CATEGORY: boolean = !!categories_new?.length;
            onPublish && onPublish({
                partner_id: Number(values?.media?.value),
                partner_code_id: Number(values?.section?.value),
                reporter_id: values?.reporter_id ? values?.reporter_id : null,
                reporter_byline: values?.reporter_byline || '',
                tag: values?.tag || '',
                ...(isShowCategoryOnPublish ? {
                    keyword: values?.keyword || '',
                    categories: [...categories_current, ...categories_new]
                } : {})
            }, IS_REFRESH_CATEGORY);
        } catch (error: any) {
            toast(`${error?.message || ''}`, CONFIG_OPTION_TOAST_ERROR);
            return error;
        }
    };

    const validationSchema = Yup.object({
        media: Yup.object().shape({
            label: Yup.string(),
            value: Yup.string(),
        }).required(`${t("This is required")}`),
        section: Yup.object().shape({
            label: Yup.string(),
            value: Yup.string(),
        }).required(`${t("This is required")}`),
        reporter_id: Yup.string().nullable(),
        reporter_byline: Yup.string().nullable(),
        tag: Yup.string().nullable(),
        keyword: isShowCategoryOnPublish ? Yup.string().required(`${t("This is required")}`) : Yup.string().nullable(),
        categories: Yup.array().of(Yup.object().shape({
            label: Yup.string(),
            value: Yup.string(),
        }).nullable()).nullable(),
        new_categories: Yup.array().of(
            Yup.object().shape({
                id: Yup.string(),
                text: Yup.string(),
            })
        ).nullable(),
        // category_name: isShowCategoryOnPublish ? Yup.string()
        //     .nullable()
        //     .test(
        //         'category-name-required',
        //         `${t("Category name is required when creating a new category")}`,
        //         function (value) {
        //             const { is_create_new_category } = this.parent;
        //             if (is_create_new_category) {
        //                 return !!value; // If creating a new category, category_name must not be empty
        //             }
        //             return true; // Otherwise, category_name is optional
        //         }
        //     ) : Yup.string().nullable(),
        is_create_new_category: Yup.boolean().nullable(),
        // category_id: isShowCategoryOnPublish ? Yup.object().shape({
        //     label: Yup.string(),
        //     value: Yup.string(),
        // })
        //     .nullable()
        //     .test(
        //         'category-id-required',
        //         `${t("Category ID is required when not creating a new category")}`,
        //         function (value) {
        //             const { is_create_new_category } = this.parent;
        //             if (!is_create_new_category) {
        //                 return !!(value && value.label && value.value); // Convert to boolean with !!
        //             }
        //             return true;
        //         }
        //     ) : Yup.object().shape({
        //         label: Yup.string(),
        //         value: Yup.string(),
        //     }).nullable(),
    });

    const CATEGORY_DEFAULT = {
        value: '',
        label: ''
    };

    const formik = useFormik({
        initialValues: {
            media: null,
            section: null,
            reporter_id: '',
            reporter_byline: '',
            tag: '',
            keyword: '',
            // category_name: '',
            // category_id: null,
            is_create_new_category: false,
            categories: [CATEGORY_DEFAULT],
            new_categories: []
        },
        validationSchema: validationSchema,
        onSubmit: handleSubmit,
    });

    // const handleAddCategory = (index: number) => {
    //     const timeArray = [...(formik.values.categories || []), (formik.values.categories || [])[(formik.values.categories || [])?.length - 1] || CATEGORY_DEFAULT];
    //     formik.setFieldValue("categories", timeArray);
    // };

    // const handleRemoveCategory = (index: number) => {
    //     const timeArray = (formik.values.categories || [])?.filter((_m, ind: number) => ind !== index);
    //     formik.setFieldValue("categories", timeArray?.length === 0 ? [CATEGORY_DEFAULT] : timeArray);
    // };

    // const handleAddNewCategory = (index: number) => {
    //     const timeArray = [...(formik.values.new_categories || []), NEW_CATEGORY_DEFAULT];
    //     formik.setFieldValue("new_categories", timeArray);
    // };

    // const handleRemoveNewCategory = (index: number) => {
    //     const timeArray = (formik.values.new_categories || [])?.filter((_m, ind: number) => ind !== index);
    //     formik.setFieldValue("new_categories", timeArray?.length === 0 ? [NEW_CATEGORY_DEFAULT] : timeArray);
    // };

    useEffect(() => {
        const _categories = categories?.map((_c: any) => ({ label: _c?.name, value: `${_c?.id}` }));

        const _options = partners?.map((item) => ({
            label: item?.name || '', value: String(item?.id),
            sections: item?.partner_codes?.map((d: any) => ({ label: d?.section_title, value: String(d?.id) })),
            reporters: item?.partner_reporters?.map((d: any) => ({ label: `${d?.reporter_id}`, value: String(d?.reporter_id) }))
        }));

        const _info_media = _options?.find((_o: any) => String(_o?.value) === String(infoPublishDefault?.media_id));
        const _info_section = _info_media?.sections?.find((_s: any) => String(_s?.value) === String(infoPublishDefault?.media_code_id));
        // const _info_reporter = _info_media?.reporters?.find((_s: any) => String(_s?.value) === String(infoPublishDefault?.media_reporter_id))?.value || '';

        const _info_reporter_id = infoPublishDefault?.media_reporter_id || '';
        const _info_reporter_byline = infoPublishDefault?.reporter_byline || '';
        const _info_tag = infoPublishDefault?.tag || '';

        const _info_categories = (infoPublishDefault?.categories?.length ? infoPublishDefault?.categories : [CATEGORY_DEFAULT])?.map((_c: any) => {
            return _categories?.find((_o: any) => String(_o?.value) === String(_c?.id));
        });
        const _info_keyword = infoPublishDefault?.keyword || '';

        setOptions((_prev: any) => _options);
        setCategoryOptions((_prev: any) => _categories);
        setTimeout(() => {
            formik.setFieldValue(`media`, _info_media);
            formik.setFieldValue(`section`, _info_section);
            formik.setFieldValue(`reporter_id`, _info_reporter_id);
            formik.setFieldValue(`categories`, _info_categories);
            formik.setFieldValue(`new_categories`, []);
            formik.setFieldValue(`keyword`, _info_keyword);
            formik.setFieldValue(`reporter_byline`, _info_reporter_byline);
            formik.setFieldValue(`tag`, _info_tag);
            formik.setFieldValue(`is_create_new_category`, false);
        }, 300);

        return () => {
            formik.setErrors({});
        }
    }, [JSON.stringify(partners), JSON.stringify(categories), JSON.stringify(infoPublishDefault)]);

    return (
        <>
            <Modal
                isOpen={isOpen}
                centered={true}
                size="md"
                scrollable={false}
            >
                <ModalHeader toggle={handleCloseClick}>
                    <>{t("Button Publish News")}</>
                </ModalHeader>
                <ModalBody className="pt-2">
                    <form onSubmit={formik.handleSubmit}>
                        <div>
                            <Row>
                                <Col sm={12} md={12} xl={12} className="mt-3">
                                    <Label htmlFor="media" className="form-label">{t('Media')}<span className="text-danger"> *</span></Label>
                                    <DropdownOption
                                        name="media"
                                        dataList={options || []}
                                        placeholder={`${t("Media")}...`}
                                        className={`dropdown-status-rounded z-hight mb-3 mb-lg-2 mb-xxl-1`}
                                        classNamePrefix="name-prefix"
                                        style={{ width: '100%' }}
                                        initialValue={formik?.values?.media}
                                        onChangeSelect={(e: any) => {
                                            // const _sections = options?.find((op: any) => (String(op?.value) === String(e?.value)))?.sections || [];
                                            // const _section = _sections?.find((op: any) => (String(op?.value) === String(infoPublish?.section?.value))) || _sections[0];
                                            // setInfoPublish((_prev: any) => ({ ..._prev, media: e }));
                                            formik.setFieldValue(`media`, e);
                                        }}
                                    />
                                    {formik.touched.media && formik.errors.media ? (
                                        <div className="text-danger mt-2">{formik.errors.media}</div>
                                    ) : null}
                                </Col>
                                <Col sm={12} md={12} xl={12} className="mt-3">
                                    <Label htmlFor="section" className="form-label">{t('Section')}<span className="text-danger"> *</span></Label>
                                    <DropdownOption
                                        name="section"
                                        dataList={options?.find((op: any) => (String(op?.value) === String((formik?.values?.media as any)?.value)))?.sections || []}
                                        placeholder={`${t("Section")}...`}
                                        className={`dropdown-status-rounded z-hight mb-3 mb-lg-2 mb-xxl-1`}
                                        classNamePrefix="name-prefix"
                                        style={{ width: '100%' }}
                                        initialValue={formik?.values?.section}
                                        onChangeSelect={(e: any) => {
                                            formik.setFieldValue(`section`, e);
                                            // setInfoPublish((_prev: any) => ({ ..._prev, section: e }));
                                        }}
                                    />
                                    {formik.touched.section && formik.errors.section ? (
                                        <div className="text-danger mt-2">{formik.errors.section}</div>
                                    ) : null}
                                </Col>
                                <Col sm={12} md={12} xl={12} className="mt-3">
                                    <Label htmlFor="reporter" className="form-label">{t('Reporter ID')}</Label>
                                    <Input
                                        name={`reporter_id`}
                                        type="text"
                                        className="form-control"
                                        id={`reporter_id`}
                                        placeholder={t('Reporter ID')}
                                        value={formik?.values?.reporter_id}
                                        onChange={(event: any) => {
                                            formik.setFieldValue(`reporter_id`, event?.target?.value);
                                            // setInfoPublish((_prev: any) => ({ ..._prev, reporter: event?.target?.value }));
                                        }}
                                    />
                                    {formik.touched.reporter_id && formik.errors.reporter_id ? (
                                        <div className="text-danger mt-2">{formik.errors.reporter_id}</div>
                                    ) : null}
                                </Col>
                                <Col sm={12} md={12} xl={12} className="mt-3">
                                    <Label htmlFor="reporter_byline" className="form-label">{t('Reporter Byline')}</Label>
                                    <Input
                                        name={`reporter_byline`}
                                        type="text"
                                        className="form-control"
                                        id={`reporter_byline`}
                                        placeholder={t('Reporter Byline')}
                                        value={formik?.values?.reporter_byline}
                                        onChange={(event: any) => {
                                            formik.setFieldValue(`reporter_byline`, event?.target?.value);
                                            // setInfoPublish((_prev: any) => ({ ..._prev, reporter: event?.target?.value }));
                                        }}
                                    />
                                    {formik.touched.reporter_byline && formik.errors.reporter_byline ? (
                                        <div className="text-danger mt-2">{formik.errors.reporter_byline}</div>
                                    ) : null}
                                </Col>
                                {isShowCategoryOnPublish && <>
                                    <Col sm={12} md={12} lg={12} className='mt-3 mb-1'>
                                        <div>
                                            <label className="form-label">
                                                {t("Category")}
                                            </label>
                                            <DropdownMultiOption
                                                name={`categories`}
                                                dataList={categoryOptions}
                                                placeholder={t('Category')}
                                                className="search-filter-category-type dropdown-status-rounded"
                                                classNamePrefix="name-prefix"
                                                initialValue={formik?.values?.categories}
                                                onChangeSelect={(e: any) => {
                                                    formik.setFieldValue(`categories`, e)
                                                }}
                                                isHasOptionAll={false}
                                            />
                                            {(formik.touched.categories as any) && (formik.errors.categories as any)?.value ? (
                                                <div className="text-danger mt-2">{(formik.errors.categories as any)?.value || ''}</div>
                                            ) : null}
                                        </div>
                                    </Col>
                                    <div className="position-relative mb-3 mt-4" style={{ border: `${!!formik?.values?.is_create_new_category ? 1 : 0}px dashed rgb(191, 193, 201)`, borderRadius: '4px', padding: '10px 12px' }}>
                                        <div className='position-absolute' style={{ backgroundColor: "var(--vz-secondary-bg)", top: '0px', transform: 'translateY(-50%)' }}>
                                            <Col sm={12} md={12} lg={12} className='mt-0 px-1'>
                                                <div className="form-check form-switch">
                                                    <input className="form-check-input" type="checkbox" role="switch" checked={!!formik?.values?.is_create_new_category} id={`is_create_new_category`}
                                                        onChange={(event: any) => {
                                                            formik.setFieldValue(`is_create_new_category`, !!event.target.checked);
                                                            formik.setFieldValue(`new_categories`, []);
                                                        }}
                                                    />
                                                    <label className="form-check-label" htmlFor={`is_create_new_category`}><span className="text-muted">{t('and')}</span> {t('Create New Category')} {!!formik?.values?.is_create_new_category && <span className="text-danger">*</span>}</label>
                                                </div>
                                            </Col>
                                        </div>
                                        {!!formik?.values?.is_create_new_category && <div className="mb-0">
                                            <Col sm={12} md={12} lg={12} className='mt-2 px-0'>
                                                <div>
                                                    <label className="form-label">
                                                        {t("New Category")}
                                                    </label>
                                                    <Input
                                                        type="text"
                                                        className="mb-2"
                                                        id="new_categories"
                                                        name="new_categories"
                                                        autocomplete={false}
                                                        value={((formik?.values?.new_categories || [])?.[0] as any)?.id || ''}
                                                        placeholder={`${t("Category Name")}...`}
                                                        onChange={(event: any) => {
                                                            formik.setFieldValue("new_categories", [{ id: event?.target?.value || '', text: event?.target?.value || '' }]);
                                                        }}
                                                    />
                                                    {(formik.touched.new_categories as any) && (formik.errors.new_categories as any)?.id ? (
                                                        <div className="text-danger mt-2">{(formik.errors.new_categories as any)?.id || ''}</div>
                                                    ) : null}
                                                </div>
                                            </Col>
                                        </div>}
                                    </div>


                                    <Col sm={12} md={12} xl={12} className="mt-0">
                                        <Label htmlFor="keyword" className="form-label">{t('Keyword')} <span className="text-danger">*</span></Label>
                                        <Input
                                            name={`keyword`}
                                            type="text"
                                            className="form-control"
                                            id={`keyword`}
                                            placeholder={t('Keyword')}
                                            value={formik?.values?.keyword}
                                            onChange={(event: any) => {
                                                formik.setFieldValue(`keyword`, event?.target?.value);
                                            }}
                                        />
                                        {formik.touched.keyword && formik.errors.keyword ? (
                                            <div className="text-danger mt-2">{formik.errors.keyword}</div>
                                        ) : null}
                                    </Col>

                                    <Col sm={12} md={12} xl={12} className="mt-3">
                                        <Label htmlFor="tag" className="form-label">{t('Tag')}</Label>
                                        <Input
                                            name={`tag`}
                                            type="text"
                                            className="form-control"
                                            id={`tag`}
                                            placeholder={t('Tag')}
                                            value={formik?.values?.tag}
                                            onChange={(event: any) => {
                                                formik.setFieldValue(`tag`, event?.target?.value);
                                            }}
                                        />
                                        {formik.touched.tag && formik.errors.tag ? (
                                            <div className="text-danger mt-2">{formik.errors.tag}</div>
                                        ) : null}
                                    </Col>
                                </>}

                                <Col sm={12} md={12} xl={12} className='mt-4 mb-3 pt-1 text-end'>
                                    <button
                                        style={{ width: '120px' }}
                                        type="submit"
                                        disabled={isPublishing}
                                        className="btn btn-primary fs-14 rounded-pill">
                                        {isPublishing ? <Spinner size="sm me-2" ></Spinner> : <></>}
                                        {t('Publish')}
                                    </button>
                                </Col>
                            </Row>
                        </div>
                    </form>
                </ModalBody>
            </Modal>
        </>
    );
};

export default React.memo(ModalPartner);
